/**
 * HorizontalArrowLeftContainer component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import { RailDisplayMode } from '@shared/types/enums/rail';

/**
 * Get the style for the HorizontalArrowLeftContainer component.
 */
const getStyle = (displayMode: RailDisplayMode) => {
  let borderRadius = 18;
  let height = 198;
  let left = 27;
  let padding = 15;
  let top = 64;
  let width = 83;
  switch (displayMode) {
    case RailDisplayMode.CHARACTER:
      borderRadius = 20;
      height = 200;
      break;
    case RailDisplayMode.EPG:
      borderRadius = 20;
      height = 72;
      left = 18;
      padding = 0;
      top = 22;
      width = 72;
      break;
    case RailDisplayMode.FILTER:
      borderRadius = 30;
      height = 60;
      left = 16;
      padding = 0;
      top = 18;
      width = 60;
      break;
    case RailDisplayMode.POSTER:
    case RailDisplayMode.RANKING_POSTER:
      height = 302;
      top = 115;
      width = 83;
      break;
    case RailDisplayMode.SQUARE:
      height = 109;
      left = 15;
      padding = 10;
      top = 40;
      width = 49;
      break;
  }
  return {
    borderRadius,
    height,
    left,
    padding,
    top,
    width,
  };
};

/**
 * Styled component for the HorizontalArrowLeftContainer component.
 */
const RailArrowContainer = styled.div<{
  arrowDirection: 'left' | 'right';
  hovered?: boolean;
  railDisplayMode: RailDisplayMode;
}>`
  ${(props) => {
    const { borderRadius, height, left, padding, top, width } = getStyle(
      props.railDisplayMode
    );
    return `
    background: rgba(0, 0, 0, 0.8);
    border-radius: ${Screen.widthRatio * borderRadius}px ${
      Screen.widthRatio * (props.arrowDirection === 'right' ? 0 : borderRadius)
    }px ${
      Screen.widthRatio * (props.arrowDirection === 'right' ? 0 : borderRadius)
    }px ${Screen.widthRatio * borderRadius}px;
    height: ${height * Screen.widthRatio}px;
    line-height: ${Screen.widthRatio * 360}px;
    opacity: ${props.hovered ? 1 : 0};
    padding-${props.arrowDirection}: ${Screen.widthRatio * padding}px;
    position: relative;
    pointer-events: auto;
    width: ${width * Screen.widthRatio}px;
    &:hover {
      opacity: 1;
    }
    & > svg {
      position: absolute;
      ${props.arrowDirection === 'left' ? 'left' : 'right'}: ${
      Screen.widthRatio * left
    }px;
      top: ${top * Screen.widthRatio}px;
    }
    `;
  }}
`;

export default RailArrowContainer;
